import axios from "axios";
import { getAttribution } from "./attribution";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("speedyz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.method === "post" && config.url === "/leads" && config.data && typeof config.data === "object") {
    const attribution = getAttribution();
    if (attribution) config.data = { ...config.data, data: { ...(config.data.data || {}), attribution } };
  }
  return config;
});

export default api;
